import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState(null);
  const openModal = (modalType: string) => {
    setActiveModal(modalType);
  };
  const closeModal = () => {
    setActiveModal(null);
  };
  const termsContent = <div className="space-y-4 text-sm" data-id="element-20">
      <h2 className="text-lg font-semibold" data-id="element-21">1. Términos de Uso</h2>
      <p data-id="element-22">
        Al acceder y utilizar "Kit de Emergencia Anti-Estrés", aceptas cumplir
        con estos términos y condiciones. Si no estás de acuerdo con alguna
        parte de estos términos, no deberás utilizar nuestro producto.
      </p>
      <h2 className="text-lg font-semibold" data-id="element-23">2. Propiedad Intelectual</h2>
      <p data-id="element-24">
        Todo el contenido incluido en "Kit de Emergencia Anti-Estrés",
        incluyendo textos, gráficos, logos, imágenes, así como la compilación de
        estos, es propiedad exclusiva de los creadores del manual y está
        protegido por las leyes de propiedad intelectual.
      </p>
      <h2 className="text-lg font-semibold" data-id="element-25">3. Restricciones de Uso</h2>
      <p data-id="element-26">
        Al adquirir "Kit de Emergencia Anti-Estrés", obtienes una licencia
        personal, no transferible y no exclusiva para utilizar el contenido. No
        está permitido:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-27">
        <li data-id="element-28">Redistribuir, vender o compartir el contenido con terceros</li>
        <li data-id="element-29">Modificar o crear trabajos derivados basados en el material</li>
        <li data-id="element-30">Utilizar el contenido con fines comerciales sin autorización</li>
      </ul>
      <h2 className="text-lg font-semibold" data-id="element-31">4. Descargo de Responsabilidad</h2>
      <p data-id="element-32">
        "Kit de Emergencia Anti-Estrés" se proporciona "tal cual", sin garantías
        de ningún tipo. No garantizamos que el contenido sea aplicable a todas
        las situaciones o que produzca resultados específicos.
      </p>
      <h2 className="text-lg font-semibold" data-id="element-33">
        5. Limitación de Responsabilidad
      </h2>
      <p data-id="element-34">
        En ningún caso los creadores de "Kit de Emergencia Anti-Estrés" serán
        responsables por daños directos, indirectos, incidentales, especiales o
        consecuentes que resulten del uso o la imposibilidad de usar nuestro
        producto.
      </p>
      <h2 className="text-lg font-semibold" data-id="element-35">6. Modificaciones</h2>
      <p data-id="element-36">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación.
      </p>
      <h2 className="text-lg font-semibold" data-id="element-37">7. Ley Aplicable</h2>
      <p data-id="element-38">
        Estos términos se regirán e interpretarán de acuerdo con las leyes
        aplicables, sin tener en cuenta sus disposiciones sobre conflictos de
        leyes.
      </p>
    </div>;
  const privacyContent = <div className="space-y-4 text-sm" data-id="element-39">
      <h2 className="text-lg font-semibold" data-id="element-40">1. Información que Recopilamos</h2>
      <p data-id="element-41">
        Al comprar "Kit de Emergencia Anti-Estrés", podemos recopilar la
        siguiente información:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-42">
        <li data-id="element-43">Información de contacto (nombre, correo electrónico, etc.)</li>
        <li data-id="element-44">
          Información de pago (procesada de forma segura por nuestros
          proveedores de pago)
        </li>
        <li data-id="element-45">Datos de uso y analítica del sitio web</li>
      </ul>
      <h2 className="text-lg font-semibold" data-id="element-46">2. Uso de la Información</h2>
      <p data-id="element-47">Utilizamos la información recopilada para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-48">
        <li data-id="element-49">Procesar tu compra y proporcionar acceso al manual</li>
        <li data-id="element-50">Comunicarnos contigo sobre tu compra</li>
        <li data-id="element-51">Mejorar nuestros productos y servicios</li>
        <li data-id="element-52">
          Enviar información sobre actualizaciones o productos relacionados
          (solo si has dado tu consentimiento)
        </li>
      </ul>
      <h2 className="text-lg font-semibold" data-id="element-53">3. Protección de Datos</h2>
      <p data-id="element-54">
        Implementamos medidas de seguridad adecuadas para proteger tu
        información personal contra acceso no autorizado, alteración,
        divulgación o destrucción.
      </p>
      <h2 className="text-lg font-semibold" data-id="element-55">4. Compartir Información</h2>
      <p data-id="element-56">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a proveedores de servicios que nos ayudan a operar
        nuestro negocio (procesadores de pago, servicios de entrega digital,
        etc.).
      </p>
      <h2 className="text-lg font-semibold" data-id="element-57">
        5. Cookies y Tecnologías Similares
      </h2>
      <p data-id="element-58">
        Utilizamos cookies y tecnologías similares para mejorar la experiencia
        del usuario, analizar el tráfico y personalizar el contenido. Puedes
        configurar tu navegador para rechazar cookies, aunque esto puede afectar
        la funcionalidad del sitio.
      </p>
      <h2 className="text-lg font-semibold" data-id="element-59">6. Tus Derechos</h2>
      <p data-id="element-60">
        Tienes derecho a acceder, corregir o eliminar tu información personal.
        Para ejercer estos derechos, contáctanos a través de los medios
        proporcionados.
      </p>
      <h2 className="text-lg font-semibold" data-id="element-61">7. Cambios a esta Política</h2>
      <p data-id="element-62">
        Podemos actualizar nuestra política de privacidad periódicamente. Te
        notificaremos cualquier cambio significativo mediante un aviso en
        nuestro sitio web.
      </p>
    </div>;
  const contactContent = <div className="space-y-6 text-sm" data-id="element-63">
      <h2 className="text-xl font-semibold" data-id="element-64">Contacto</h2>
      <p data-id="element-65">
        Para cualquier consulta, sugerencia o problema relacionado con "Kit de
        Emergencia Anti-Estrés", puedes contactarnos a través de los siguientes
        medios:
      </p>
      <div className="space-y-2" data-id="element-66">
        <p className="font-medium" data-id="element-67">
          Correo electrónico: soporte@kitantiestres.com
        </p>
        <p className="font-medium" data-id="element-68">
          Horario de atención: Lunes a Viernes, 9:00 - 18:00 (GMT-3)
        </p>
      </div>
      <div className="mt-6 space-y-4" data-id="element-69">
        <h3 className="text-lg font-medium" data-id="element-70">Formulario de Contacto</h3>
        <div className="space-y-3" data-id="element-71">
          <div className="space-y-1" data-id="element-72">
            <label className="block text-sm font-medium" data-id="element-73">Nombre</label>
            <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md" data-id="element-74" />
          </div>
          <div className="space-y-1" data-id="element-75">
            <label className="block text-sm font-medium" data-id="element-76">
              Correo electrónico
            </label>
            <input type="email" className="w-full px-3 py-2 border border-gray-300 rounded-md" data-id="element-77" />
          </div>
          <div className="space-y-1" data-id="element-78">
            <label className="block text-sm font-medium" data-id="element-79">Mensaje</label>
            <textarea className="w-full px-3 py-2 border border-gray-300 rounded-md" rows={4} data-id="element-80"></textarea>
          </div>
          <button className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors" data-id="element-81">
            Enviar mensaje
          </button>
        </div>
      </div>
    </div>;
  return <footer className="bg-gray-50 py-12 mt-20" data-id="element-82">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83">
        <div className="text-center" data-id="element-84">
          <h2 className="text-2xl font-bold text-green-800 mb-6" data-id="element-85">
            KIT DE EMERGENCIA ANTI-ESTRÉS
          </h2>
          <div className="flex justify-center space-x-6 mb-8" data-id="element-86">
            <button onClick={() => openModal('terms')} className="text-sm text-gray-600 hover:text-green-700 transition-colors" data-id="element-87">
              Términos y Condiciones
            </button>
            <button onClick={() => openModal('privacy')} className="text-sm text-gray-600 hover:text-green-700 transition-colors" data-id="element-88">
              Política de Privacidad
            </button>
            <button onClick={() => openModal('contact')} className="text-sm text-gray-600 hover:text-green-700 transition-colors" data-id="element-89">
              Contacto
            </button>
          </div>
          <p className="text-xs text-gray-500 max-w-2xl mx-auto" data-id="element-90">
            © 2025 Todos los derechos reservados
          </p>
          <p className="text-xs text-gray-500 mt-4 max-w-2xl mx-auto" data-id="element-91">
            Los resultados pueden variar. El éxito depende del esfuerzo y
            dedicación de cada persona.
          </p>
        </div>
      </div>
      {/* Legal Modals */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" content={termsContent} data-id="element-92" />
      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" content={privacyContent} data-id="element-93" />
      <LegalModal isOpen={activeModal === 'contact'} onClose={closeModal} title="Contacto" content={contactContent} data-id="element-94" />
    </footer>;
}